import Vue from 'vue';

function reportError(data) {
  console.error(data);
}

Vue.config.errorHandler = function(err, vm, info) {
  reportError({
    intr: 'Vue errorHandler',
    desc: {
      msg: err.message,
      info
    },
    stack: err.stack
  });
};

export default reportError;
